module.exports = __webpack_public_path__ + "static/rodrigoheadshot-94e5084f5a1e7bd125da01d76e509428.jpg";